define('controllers/hotelcontacts',['require'],function(require) {
    return function() {
        var hotelId = window.ServerData.feData.hotelId;
        var btnSave = $("#btnSaveContact"),
            errormsg = $("#errormsg"),
            viewContacts = $("#viewContacts"),
            contactName = $("#contactName"),
            manageContact = $("#manageContact"),
            contactId = null;

        getContacts();

        $("#btnAdd").on("click", function () {
            contactId = null;

            viewContacts.hide();
            manageContact.show();
            contactName.focus();

            contactName.val("");
            $("#contactTitle").val("");
            $("#contactEmail").val("");
            $("#contactPhone").val("");
            $("#SendISPR").prop('checked', false);
            $("#InvoiceContact").prop('checked', false);
            $("#Note").val("");
        });

        $("#btnCancel").on("click", function () {
            viewContacts.show();
            manageContact.hide();
        });

        btnSave.on("click", function () {
            var $this = $(this),
                loading = $(this).next();

            $this.hide();
            loading.show();
            errormsg.hide();

            $.ajax({
                type: 'POST',
                url: "contactAJAX.aspx",
                data: {
                    hotelId: hotelId,
                    ContactID: contactId,
                    Name: contactName.val(),
                    Title: $("#contactTitle").val(),
                    EMailAddress: $("#contactEmail").val(),
                    PhoneMain: $("#contactPhone").val(),
                    SendISPR: $("#SendISPR").is(":checked"),
                    InvoiceContact: $("#InvoiceContact").is(":checked"),
                    Note: $("#Note").val()
                },
                success: function (contacts) {
                    contactId = null;
                    bindContacts(contacts);
                    $this.show();
                    loading.hide();
                },
                error: function () {
                    errormsg.show().html("Something went wrong. Please re-load the page and try again or contact Adestinn Support.");
                    $this.show();
                    loading.hide();
                }
            });
        });

        function getContacts() {
            $("#contacts").html("<tr><td colspan=\"7\"><img alt=\"loading...\" style=\"height:20px;width:20px;\" src=\"https://adestinn2blob.blob.core.windows.net/images/loading.gif\" /></td></tr>");
            $.ajax({
                type: 'POST',
                url: "contactAJAX.aspx",
                data: { hotelId: hotelId },
                success: function (contacts) {
                    bindContacts(contacts);
                },
                error: function () {
                    errormsg.show().html("Something went wrong. Please re-load the page and try again or contact Adestinn Support.");
                    $("#contacts").html("<tr><td colspan=\"7\"></td></tr>");
                }
            });
        }

        function bindContacts(contactsData) {
            viewContacts.show();
            manageContact.hide();

            var emptyTemplate = "<tr><td colspan=\"7\"><strong>No Contacts</strong></td></tr>",
                rowTemplate = "<tr>" +
                    "<td><a data-contactId='{0}' href='#'>Edit</a></td>" +
                    "<td>{1}</td>" +
                    "<td>{2}</td>" +
                    "<td>{3}</td>" +
                    "<td>{4}</td>" +
                    "<td>{5}</td>" +
                    "<td>{7}</td>" +
                    "<td>{8}</td>" +
                    "<td>{6}</td>" +
                    "<td><a data-deletecontactId='{0}' href='#'>Delete</a></td>" +
                    "</tr>",
                rows = [],
                contactsBody = $("#contacts");

            var contacts = [];
            try {
                contacts = JSON.parse(contactsData);
            } catch (err) {
                errormsg.show().html(contactsData);
            }

            if (contacts.length > 0 && contacts[0].Name != undefined) {
                for (var i = contacts.length - 1; i >= 0; i--) {
                    var contact = contacts[i];
                    rows.push(rowTemplate.format(contact.ContactID, contact.Name, contact.Title, contact.EMailAddress, contact.PhoneMain, contact.SendISPR, contact.CreateDate, contact.InvoiceContact, contact.Note));
                }
                contactsBody.html(rows.join(""));

                $("#contacts a[data-contactId]").on("click", function (e) {
                    e.preventDefault();
                    //just grab values from row cells
                    var $this = $(this),
                        Name = $this.parent().next(),
                        Title = Name.next(),
                        Email = Title.next(),
                        Phone = Email.next();
                        Note = Phone.next().next().next();
                    var SendISPR = Phone.next().html().toLowerCase() === 'no' ? false : true;
                    // This is the issues.  :-(
                    var InvoiceContact = Phone.next().next().html().toLowerCase() === 'no' ? false : true;

                    contactId = $this.attr("data-contactId");
                    contactName.val(Name.text());
                    $("#contactTitle").val(Title.text());
                    $("#contactEmail").val(Email.text());
                    $("#contactPhone").val(Phone.text());
                    $("#Note").val(Note.text());
                    SendISPR ? $("#SendISPR").prop('checked', true) : $("#SendISPR").prop('checked', false);
                    InvoiceContact ? $("#InvoiceContact").prop('checked', true) : $("#InvoiceContact").prop('checked', false);

                    viewContacts.hide();
                    manageContact.show();
                    contactName.focus();
                });

                $("#contacts a[data-deletecontactId]").on("click", function (e) {
                    e.preventDefault();

                    contactId = $(this).attr("data-deletecontactId");

                    $.ajax({
                        type: 'POST',
                        url: "contactAJAX.aspx",
                        data: { hotelId: hotelId, ContactID: contactId },
                        success: function (contacts) {
                            contactId = null;
                            bindContacts(contacts);
                        },
                        error: function () {
                            errormsg.show().html("Something went wrong. Please re-load the page and try again or contact Adestinn Support.");
                        }
                    });
                });

            } else {
                contactsBody.html(emptyTemplate);
            }
        }
    };
});

